// @ts-strict-ignore
import clsx from 'clsx'
import { MouseEvent, useRef } from 'react'

import { CardType } from '@/entities/card/types/types'

import { ArrowDown } from '@/shared/lib/@deprecated/iport-icons'

import { Tag } from '../tag/tag'

import cl from './tags.module.scss'
import { DiscountItem } from '@/screens/Discount/page/lib/discountSaleAdapter'

type TagsProps = {
	tags: DiscountItem[]
	type: CardType
	isOpen?: boolean
	onToggle?: () => void
	size?: 'S' | 'M'
}

export const Tags = (props: TagsProps) => {
	const { tags, type = 'regular', isOpen, onToggle } = props
	const tagsListRef = useRef<HTMLUListElement>(null)

	const showButton = tags.length > 1
	const tagsMarkup = tags.map(tag => (
		<li key={tag.ID}>
			<Tag tag={tag} />
		</li>
	))

	const toggleTagsPanel = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		onToggle?.()

		const el = tagsListRef.current

		if (el.style.maxHeight) {
			el.style.maxHeight = null
		} else {
			el.style.maxHeight = `${el.scrollHeight}px`
		}
	}

	const buttonClasses = clsx(cl.tags__button, {
		[cl.tags__button__active]: isOpen
	})

	return (
		<div className={clsx(cl.tools, cl[type])}>
			<div className={cl.tags}>
				<ul className={cl.tags__list} ref={tagsListRef}>
					{tagsMarkup}
				</ul>
				{showButton && (
					<button className={buttonClasses} onClick={toggleTagsPanel}>
						<ArrowDown size={18} />
					</button>
				)}
			</div>
		</div>
	)
}
